var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, when, flow, makeObservable } from 'mobx';
import { runtime } from '../../../runtime/Runtime';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { StageEmergeAnswer } from './StageEmergeAnswer';
export class StageEmerge {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get stage() {
        return this.parent;
    }
    get app() {
        return this.stage.app;
    }
    isCurrentlyEmerging = false;
    get emergeAnswer() {
        return new StageEmergeAnswer(this);
    }
    stageItem = flow(function* (item, { immediate } = {}) {
        if (!item)
            return;
        yield when(() => !this.isCurrentlyEmerging);
        if (runtime.isServerRuntime)
            return;
        // console.log('stageItem', item);
        this.isCurrentlyEmerging = true;
        if (item.type === 'answer') {
            yield this.app.directive.directivePoseQuestion.stageAnswer(item);
        }
        this.isCurrentlyEmerging = false;
    });
}
__decorate([
    observable
], StageEmerge.prototype, "isCurrentlyEmerging", void 0);
__decorate([
    memoize
], StageEmerge.prototype, "emergeAnswer", null);
